import { useVdpPricing } from '~/context/vdp/UserVehicleContext';

export default function useGetCoApplicantStateEligible(): boolean {
  const {
    financeInfo: {
      coApplicantEligibility: { coSignerAllowed = false } = {}
    } = {}
  } = useVdpPricing();

  return coSignerAllowed;
}
